export default "__VITE_ASSET__db0ff035__"